import { useEffect, useRef } from 'react';

/**
 * One refetch when the browser tab becomes visible again.
 * Rapid visibility events collapse into a single call.
 */
export function useDocumentVisibleRefetch(refetch: () => void, enabled = true) {
  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;

  useEffect(() => {
    if (!enabled || typeof document === 'undefined') return undefined;

    let timer: ReturnType<typeof setTimeout> | null = null;
    const onChange = () => {
      if (document.visibilityState !== 'visible') return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        refetchRef.current();
      }, 400);
    };

    document.addEventListener('visibilitychange', onChange);
    return () => {
      document.removeEventListener('visibilitychange', onChange);
      if (timer) clearTimeout(timer);
    };
  }, [enabled]);
}
